import request, { formatRequest } from "@/utils/request"

const APIReturnLanguage = {
  getLanguageList() {
    return request.get("/go-api/v1/lan/list")
  },
  // 是否发布 1-是 2-取消发布
  updateLanguageList(data: { code: string; is_publish: number }) {
    return formatRequest(request.post("/go-api/v1/lan/update", data), {
      success: {
        1000: t("OperationSuccessful"),
      },
    })
  },

  deleteLanguage(code) {
    return request.post("/go-api/v1/lan/del", { code })
  },
  searchLanguage(params) {
    return request.post("/go-api/v1/lan/all", params)
  },

  setDefaultLanguage(code) {
    return request.post("/go-api/v1/lan/default", { code })
  },
  addLanguage(lan) {
    return request.post("/go-api/v1/lan/add", { lan })
  },

  // 这是后端给的接口 没办法 只能写成这样
  getLoginPage(code: string) {
    return request.post("/go-api/v1/lan/getLoginPage", { code })
  },
  getDetails(code: string) {
    return request.post("/go-api/v1/lan/getDetails", { code })
  },
  getSolution(code: string) {
    return request.post("/go-api/v1/lan/getSolution", { code })
  },
  getMethod(code: string) {
    return request.post("/go-api/v1/lan/getMethod", { code })
  },
  getCheck(code: string) {
    return request.post("/go-api/v1/lan/getCheck", { code })
  },
  getReturnPage(code: string) {
    return request.post("/go-api/v1/lan/getReturnPage", { code })
  },
  getReturnItem(code: string) {
    return request.post("/go-api/v1/lan/getReturnItem", { code })
  },
  saveLoginPage(code: string, data) {
    return request.post("/go-api/v1/lan/saveLoginPage", { code, data })
  },
  saveDetails(code: string, data) {
    return request.post("/go-api/v1/lan/saveDetails", { code, data })
  },
  saveSolution(code: string, data) {
    return request.post("/go-api/v1/lan/saveSolution", { code, data })
  },
  saveMethod(code: string, data) {
    return request.post("/go-api/v1/lan/saveMethod", { code, data })
  },
  saveCheck(code: string, data) {
    return request.post("/go-api/v1/lan/saveCheck", { code, data })
  },
  saveReturnPage(code: string, data) {
    return request.post("/go-api/v1/lan/saveReturnPage", { code, data })
  },
  saveReturnItem(code: string, data) {
    return request.post("/go-api/v1/lan/saveReturnItem", { code, data })
  },

  getOriginData(code: string) {
    return request.post("/go-api/v1/lan/reset", { code })
  },
}

export default APIReturnLanguage
